export default __webpack_public_path__ + "static/media/places-around-me.ce88d210.svg";